import { CompanyDetails } from '@/types/companies';
import { Card, Typography, Stack } from '@mui/material';
import { SVLink } from '@/components/core';
import { ROUTES } from '@/constants/routes';
import { Status } from '@/types/common';
import { useState } from 'react';
import { useGetUser } from '@/hooks/requests/useUser';
import ReactivateModal from '../modals/ReactivateModal';
import { useReactivateCompany } from '@/hooks/requests/useCompanies';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import CompanyDeactivateModal from './modals/CompanyDeactivateModal';

type CompanyDetailsActionsProps = {
  companyDetails: CompanyDetails;
};

export default function CompanyDetailsActions({
  companyDetails,
}: CompanyDetailsActionsProps) {
  const { uuid } = companyDetails;

  const { scrollToTop } = useScrollToTop();
  const { canSeeTeammates } = useGetUser();
  const [openDeactivate, setOpenDeactivate] = useState(false);
  const [openReactivate, setOpenReactivate] = useState(false);
  const { reactivateCompany, isReactivateCompanyPending } =
    useReactivateCompany(uuid);

  const isActive = companyDetails.status === Status.ACTIVE;
  const showAddTeammate = isActive && canSeeTeammates;

  return (
    <Card variant="fullHeight" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
        Actions
      </Typography>
      <Stack spacing={2}>
        {showAddTeammate && (
          <SVLink
            to={`${ROUTES.TEAMMATES_ADD}?companyId=${uuid}`}
            onClick={() => {}}>
            Add Teammate
          </SVLink>
        )}
        {isActive ? (
          <SVLink isWarningLink onClick={() => setOpenDeactivate(true)} to="">
            Deactivate Company
          </SVLink>
        ) : (
          <SVLink isWarningLink onClick={() => setOpenReactivate(true)} to="">
            Reactivate Company
          </SVLink>
        )}
        <CompanyDeactivateModal
          id={uuid}
          open={openDeactivate}
          setOpen={setOpenDeactivate}
        />
        <ReactivateModal
          userType="Company"
          open={openReactivate}
          setOpen={setOpenReactivate}
          reactivate={reactivateCompany}
          isReactivatePending={isReactivateCompanyPending}
          scrollToTop={scrollToTop}
        />
      </Stack>
    </Card>
  );
}
